/**
 * Time duration constants in seconds for API and subgraph queries
 */

// Base units in seconds
export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
export const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
export const SECONDS_PER_WEEK = 7 * SECONDS_PER_DAY;

// Common time periods in seconds (for subgraph queries)
export const TIME_PERIODS_SECONDS = {
  ONE_HOUR: SECONDS_PER_HOUR,
  TWENTY_FOUR_HOURS: SECONDS_PER_DAY,
  FORTY_EIGHT_HOURS: 2 * SECONDS_PER_DAY,
  SEVEN_DAYS: SECONDS_PER_WEEK,
  THIRTY_DAYS: 30 * SECONDS_PER_DAY,
  ONE_YEAR: 365 * SECONDS_PER_DAY,
  TWO_YEARS: 730 * SECONDS_PER_DAY,
} as const;
